import { render, staticRenderFns } from "./OrderTypes.vue?vue&type=template&id=3a37fd34"
import script from "./OrderTypes.vue?vue&type=script&lang=ts"
export * from "./OrderTypes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports